var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"px-20 md:px-30 py-8 bg-midnight"},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }